'use strict';
var React = require('react');
var i18nHelper = require('../../helper/i18n');

var ProcessAlert = React.createClass({

    propTypes: {
        max: React.PropTypes.string.isRequired,
        value: React.PropTypes.string.isRequired,
    },

    render: function () {
        var max = this.props.max;
        var value = this.props.value;
        var w = (value / max * 100)+'%';
        return (
            <div className='pop-alert-cover' >
                <div className='pop-alert'>
                    <p className="content">{i18nHelper.get('SAVING')}</p>
                    <div className='process-back'>
                        <div className='process-value' style={{width: w}}></div>
                    </div>
                </div>
            </div>
        );
    },


});

module.exports = ProcessAlert;



// WEBPACK FOOTER //
// ./src/views/Review/ProcessAlert.jsx